export const MIN_CALLBACK_NOW_DELAY = 1; // Seconds
export const DEFAULT_CALLBACK_NOW_DELAY = 30; // Seconds
export const MAX_CALLBACK_NOW_DELAY = 120; // Seconds
export const MIN_CALLBACK_STEP = 5; // Seconds

export type CallbackRadioOption = "callback-user-now" | "callback-user-with-delay";
export type CallbackFormVariant = "active-call" | "post-call";
